// For legacy purposes, preserve the UMD of the public API of Meet Hour
// external API (a.k.a. MeetHourExternalAPI).
module.exports = require('./external_api').default;
